import { Box, Divider, rem, Text } from "@mantine/core";

interface FollowUpSuggestionsProps {
    suggestions: string[];
    onSuggestionClick: (suggestion: string) => void;
    /** Maximum number of suggestions to display. Defaults to all suggestions. */
    maxSuggestions?: number;
    /** Use compact styling (less padding). Defaults to false. */
    compact?: boolean;
    /** Title to display above the suggestions. Defaults to "Follow-ups". */
    title?: string;
}

export const FollowUpSuggestions = ({
    suggestions,
    onSuggestionClick,
    maxSuggestions,
    compact = false,
    title = "Follow-ups",
}: FollowUpSuggestionsProps) => {
    if (!suggestions || suggestions.length === 0) {
        return null;
    }

    const displayedSuggestions = maxSuggestions
        ? suggestions.slice(0, maxSuggestions)
        : suggestions;

    return (
        <Box mt={compact ? rem(12) : rem(24)}>
            <Text fw={700} size={compact ? "sm" : "md"} mb={rem(8)}>
                {title}
            </Text>
            <Divider mb={rem(4)} />
            {displayedSuggestions.map((suggestion, index) => (
                <Box
                    key={`suggestion-${suggestion.slice(0, 20)}-${index}`}
                    onClick={() => onSuggestionClick(suggestion)}
                    style={(theme) => ({
                        display: "flex",
                        alignItems: "flex-start",
                        gap: rem(8),
                        padding: `${rem(compact ? 8 : 10)} ${rem(4)}`,
                        borderBottom: `1px solid ${theme.colors.gray[2]}`,
                        cursor: "pointer",
                        "&:hover": {
                            backgroundColor: theme.colors.gray[0],
                        },
                    })}
                >
                    <Text size="sm" c="gray.5" style={{ flexShrink: 0, lineHeight: 1.5 }}>
                        ↳
                    </Text>
                    <Text size={compact ? "xs" : "sm"} c="gray.7" style={{ lineHeight: 1.5 }}>
                        {suggestion}
                    </Text>
                </Box>
            ))}
        </Box>
    );
};
